module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "title": "Copyright"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("InterVarsity Press "), _c('br'), _vm._v("\n  P.O. Box 1400 "), _c('br'), _vm._v("\n  Downers Grove, IL 60515-1426"), _c('br'), _vm._v("\n  World Wide Web: "), _c('a', {
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("www.ivpress.com")])]), _c('br'), _vm._v("\n  Email: "), _c('a', {
    attrs: {
      "href": "mailto:email%40ivpress.com?subject="
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("email@ivpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("©2013 by Michael Card")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <"), _c('a', {
    attrs: {
      "href": "http://www.intervarsity.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("www.intervarsity.org")])]), _vm._v(">.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Scripture quotations, unless otherwise indicated, are taken from the Holman Christian Standard Bible, copyright ©1999, 2000, 2002, 2003 by Holman Bible Publishers, Nashville, Tennessee. Used by permission HCSB Holman Bible Publishers. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Design: Cindy Kiple"), _c('br'), _vm._v("\n  Images: Jesus healing a leper (mosaic), Byzantine School, Duomo, Monreale, Sicily, Italy, Giraudon. The Bridgeman Art Library.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("ISBN 978-0-8308-3812-7 (print)"), _c('br'), _vm._v("\n  ISBN 978-0-8308-8441-4 (digital)")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 60
// module chunks = 0